import React, {useEffect, useState} from "react";
import "./QuantitySelector.css";

const QuantitySelector: React.FC<{
	productQuantity: number;
	max?: number;
	onQuantityChange: (quantity: number) => void;
}> = ({ productQuantity, max, onQuantityChange }) => {
	const [quantity, setQuantity] = useState(productQuantity);
	const [isEditing, setIsEditing] = useState(false);
	const isAtMax = max !== undefined && quantity >= max;
	
	useEffect(() => {
		setQuantity(productQuantity);
	}, [productQuantity])

	const handleInputChange = (e) => {
		let inputValue = e.target.value.replace(/^0+/, "");
		if (!inputValue || inputValue < 0) {
			inputValue = 0;
		}
		let newQuantity = parseInt(inputValue, 10);
		if (max !== undefined && newQuantity > max) {
			newQuantity = max;
		}
		setQuantity(newQuantity);
		onQuantityChange(newQuantity);
	};

	const handleIncrement = () => {
		if (isAtMax) {
			return;
		}
		const newQuantity = quantity + 1;
		setQuantity(newQuantity);
		onQuantityChange(newQuantity);
	};

	const handleDecrement = () => {
		if (quantity >= 0) {
			const newQuantity = quantity - 1;
			setQuantity(newQuantity);
			onQuantityChange(newQuantity);
		}
	};

	const handleBlur = () => {;
		if (quantity < 1) {
			setQuantity(0);
		}
		setIsEditing(false);
	};

	const handleFocus = () => {
		setIsEditing(true);
	};

	return (
		<div className="quantity-selector-container">
			<button className="quantity-selector-btn" onClick={handleDecrement} disabled={quantity < 1}>
				-
			</button>
			{isEditing ? (
				<input
					className="quantity-selector-input"
					type="number"
					value={quantity ? quantity.toString() : 0}
					onChange={handleInputChange}
					onBlur={handleBlur}
					autoFocus
				/>
			) : (
				<span className="quantity-selector-value" onClick={handleFocus}>
					{quantity}
				</span>
			)}
			<button className="quantity-selector-btn" onClick={handleIncrement} disabled={isAtMax}>
				+
			</button>
		</div>
	);
};

export default QuantitySelector;
